import { CategoryEntity } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: categories,
  selectors: categorySelectors,
} = createEntitySlice<CategoryEntity>("categories")
